<ngx-ui-loader [loaderId]="'feeder'"></ngx-ui-loader>

<div class="container-fluid" style="padding: 0px;">
    <div class="row" style="margin: 0px;">
        <div class="col-md-3">
            <mat-card style="box-shadow: 0px 0px 5px 5px #888888;border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF; padding: 0px; height: auto; margin: 0px;">
                <mat-card-header style="background-color: red; display: flex; justify-content: center;  ">
                    <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF; text-align: center;">FEEDER STATUS </b> 
                </mat-card-header>

                <mat-card-content style="padding-right: 10%; padding-left: 10%;">
                    <table style="font-size: 100%;font-weight: bold;" class="responsive-table">
                        <tbody style="width: 100%;" *ngIf="allTileData">
                            <tr>
                                <td style="width: 10%;"><span style="color: rgb(0, 255, 174);">●</span></td>
                                <td style="width: 70%;">Total Feeders :</td>
                                <td style="width: 20%;">
                                  <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('all', 'tile')">&nbsp;&nbsp;&nbsp;{{allTileData.total}}</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 10%;"><span style="color:  green;">●</span></td>
                                <td style="width: 75%;">Online Feeders :</td>
                                <td style="width: 15%;">
                                  <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('online', 'tile')">&nbsp;&nbsp;&nbsp;{{allTileData.online}}</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 10%;"><span style="color:  red;">●</span></td>
                                <td style="width: 70%;">Alert Feeders :</td>
                                <td style="width: 20%;">
                                  <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('alert', 'tile')">&nbsp;&nbsp;&nbsp;{{allTileData.alert}}</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 0%;"><span style="color: rgb(0, 242, 255);">●</span></td>
                                <td style="width: 85%;">Normal Feeders :</td>
                                <td style="width: 15%;">
                                  <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('normal', 'tile')">&nbsp;&nbsp;&nbsp;{{allTileData.normal}}</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 10%;"><span style="color: black;">●</span></td>
                                <td style="width: 75%;">Offline Feeders :</td>
                                <td style="width: 15%;">
                                  <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('offline', 'tile')">&nbsp;&nbsp;&nbsp;{{allTileData.offline}}</b></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-md-5">
            <mat-card style="box-shadow: 0px 0px 5px 5px #888888;border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF; padding: 0px; height: 18.7vh;">
                <mat-card-header style="background-color: red; display: flex; justify-content: center; ">
                    <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF; text-align: center;">ALERT PARAMETER STATUS </b> 
                </mat-card-header>
                <mat-card-content style="padding-left: 7%; padding-right: 7%;">

                    <div class="row">
                        <div class="col-md-6" >
                            <table style="font-size: 100%;font-weight: bold;">
                                <tbody style="width: 100%; ">
                                    <tr>
                                        <td style="width: 70%;">OVERLOAD :</td>
                                        <td style="width: 20%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('overLoad', 'alert')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramAlertStatus.overload}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 75%;">UNDERLOAD :</td>
                                        <td style="width: 15%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('underLoad', 'alert')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramAlertStatus.underload}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">CRITICAL LOAD :</td>
                                        <td style="width: 20%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('criticalLoad', 'alert')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramAlertStatus.criticalLoad}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 85%;">LUG TEMP :</td>
                                        <td style="width: 15%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('ductTemp', 'alert')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramAlertStatus.lugtemp}}</b></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="col-md-6">
                            <table style="font-size: 100%;font-weight: bold;">
                                <tbody style="width: 100%; ">
                                    <tr>
                                        <td style="width: 70%;">HIGH VOLTAGE :</td>
                                        <td style="width: 20%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('highVoltage', 'alert')">&nbsp;&nbsp;&nbsp;{{paramAlertStatus.highVolt}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 75%;">LOW VOLTAGE :</td>
                                        <td style="width: 15%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('lowVoltage', 'alert')">&nbsp;&nbsp;&nbsp;{{paramAlertStatus.lowVolt}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">IUbalance :</td>
                                        <td style="width: 20%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('IUnbalance', 'alert')">&nbsp;&nbsp;&nbsp;{{paramAlertStatus.IUnbalance}}</b></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 85%;">VUnbalance :</td>
                                        <td style="width: 15%;">
                                          <a><b style="cursor: pointer; color: rgb(239, 128, 0);" (click)="popupTable('VUnbalance', 'alert')">&nbsp;&nbsp;&nbsp;{{paramAlertStatus.VUnbalance}}</b></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </mat-card-content>

            </mat-card>
        </div>
        
        <div class="col-md-4">
            <mat-card style="box-shadow: 1px 1px 1px 1px #888888; border: 1px solid #000000; padding: 0;">
               <!-- <agm-map #gm [latitude]="lat1" [longitude]="lng1" [zoom]="4" [fullscreenControl]="true" [mapTypeControl]="false"
                         style="height: 17.5vh; width: 100%;">
                  <agm-marker *ngFor="let data of mapData; let i = index" [latitude]="data.latitude" [longitude]="data.longitude"
                              (mouseOver)="onMouseOver(infoWindow, gm)" (markerClick)="transformerClicked(data)"
                              [iconUrl]="data.datareceived && data.alert.length == 0 ? greenTransformerPath : 
                                          data.datareceived && data.alert.length > 0 ? redTransformerPath : blackTransformerPath">
                    <agm-info-window [disableAutoPan]="false" #infoWindow>
                      <p>Transformer Id: {{ data.transformerid }}</p>
                      <p>Site Name: {{ data.sitename }}</p>
                      
                      <p *ngIf="data.datareceived" style="color: green;">Power: On</p>
                      <span *ngIf="!data.datareceived" style="color: red;">
                        <p>Power: Off</p>
                      </span>
                      <span *ngIf="data?.alert.length > 0" style="color: red;">
                        <p *ngFor="let param of data.alert">
                          {{ param.parametername | slice:2 }}: {{ param.mparametervalue }}
                        </p>
                      </span>
                    </agm-info-window>
                  </agm-marker>
                </agm-map> -->
            </mat-card>
        </div>
    </div>
</div>

<div class="row" style="padding-top: 2%;">
    <div class="col-md-3">
        <mat-form-field class="form-element" style="margin-left: 2%; width: 100%;">
            <mat-label>Feeder Selection </mat-label>
            <mat-select [(value)]="displayedFeeder">
                <mat-option  *ngFor="let feeder of displayedOptions" [value]="feeder" (click)="getFeederData(displayedFeeder)" >
                    {{feeder}}
                  </mat-option>
              </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-3">
        <mat-form-field class="form-element" style="margin-left:2%; width: 100%;">
            <mat-label>Duration </mat-label>
            <mat-select [(value)]="timeFilter">
                <mat-option  *ngFor="let time of timeOptions" [value]="time" (click)="dateSelection()" >
                    {{time}}
                  </mat-option>
              </mat-select>
        </mat-form-field>
    </div>

    <div class="col-md-2">
        <button mat-raised-button color="primary" style="width: 100%;" (click)="openGatewayReport()">
            <mat-icon>description</mat-icon> Gateway Report
        </button>
    </div>
    <div class="col-md-2">
        <button mat-raised-button color="warn" style="width: 100%;" (click)="openAlertReport()">
            <mat-icon>warning</mat-icon> Alert Report
        </button>
    </div>
    <div class="col-md-2">
        <button mat-raised-button color="blue" style="width: 100%;" (click)="openManagerSettings()">
            <mat-icon>settings</mat-icon> Manager
        </button>
    </div>
</div>

<mat-card style="height: 50vh;">
    <mat-card-content>
        <div>
            <!--PARAM BUTTONS COME HERE-->
            <div class="param-button-container" >
                <button mat-raised-button color="primary" *ngFor="let param of paramList" 
                (click)="parameterSelection(param)" class="param-button" [class.active]="param === selectedParam">{{ param }}</button>
            </div>
        </div>
        <ngx-ui-loader [loaderId]="'feederChanger'"></ngx-ui-loader>
        <div *ngIf="!isFeederData" style="align-items: center; text-align: center; "> 
            <span style="margin-top: 100%; justify-content: center;">THERE IS NO DATA AVALIABLE FOR {{timeFilter}}</span>
            <!--<img src="assets/images/warning.gif" alt="Warning" style="height: 30vh;">-->
        </div>
        <div class="col-md-12 graph-container" style="height: 30vh; width: 100%;"  #individual_graph></div>
    </mat-card-content>
</mat-card>